import axios from 'axios';
import { mainApiBaseUrl } from 'src/config';
import { SurveyResponseAnswer } from '@x-guard/xgac-types/xgac';

export const mainApiConfig = {
  baseURL: mainApiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
};

export const mainApi = axios.create(mainApiConfig);

export const getSurveyQuestions = async (token: string) => {

  const config = {
    headers: {
      Authorization: token,
    },
  };

  const response = await mainApi.get(`/survey-responses/questions/${token}`, config);
  return response.data;

};

export const updateSurveyResponses = async (token: string, answers: SurveyResponseAnswer[], isCompleted?: boolean) => {

  const config = {
    headers: {
      Authorization: token,
    },
  };

  const payload = {
    answers,
    ...(isCompleted !== undefined && { isCompleted }),
  };

  const response = await mainApi.patch('/survey-responses/submit', payload, config);
  return response.data;

};
